export default __webpack_public_path__ + "static/media/crop-width.f914100b.png";